import { storage } from '@itau-loans-www/utils'

import common from '../common/consignado'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default (key) => {
  const hasINSSOffer = storage.session.getItem(`${storageName}_leadData`)
    ?.tracking?.hasINSSOffer

  const commonParameters = common()

  const payloadSchema = (key) => {
    const offerType = hasINSSOffer ? 'com-oferta' : 'sem-oferta'

    const payload = {
      custom_path: `/emprestimo/consignado/${offerType}`,
      detail: key,
      ...commonParameters
    }

    return payload
  }

  return payloadSchema(key) ?? {}
}
